// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__23Spk","title":"ClientReferral_title__2jWwk","itemText":"ClientReferral_itemText__1SUa3"};